import AzitTest from "../../../../src/events/2020/08/azit-test/main.js";
import * as React from 'react';
export default {
  AzitTest,
  React
};